import { HOME } from "@/constants/testIds";
import { Car, Route, Bus, Heart, Ship, Compass } from "lucide-react";

const services = [
    {
        icon: Compass,
        title: "Custom Holiday Packages",
        desc: "Tailor-made itineraries across the Western Ghats & South India, priced for every budget.",
    },
    {
        icon: Car,
        title: "Car Rental",
        desc: "Clean, well-maintained cars with courteous drivers for city rides and airport transfers.",
    },
    {
        icon: Route,
        title: "Outstation Cabs",
        desc: "Comfortable one-way & round trips to any destination, available round the clock.",
    },
    {
        icon: Bus,
        title: "Bus Booking",
        desc: "AC & Non-AC 2x3 buses for groups, schools and pilgrimages at fair rates.",
    },
    {
        icon: Heart,
        title: "Wedding Transport",
        desc: "Fleet arrangements for the big day — guests moved smoothly, stress-free.",
    },
    {
        icon: Ship,
        title: "Cruise Services",
        desc: "Curated cruise experiences added to your holiday for that extra memory.",
    },
];

const Services = () => {
    return (
        <section id="services" className="bg-[#F3F1E7] py-24">
            <div className="mx-auto max-w-7xl px-5 md:px-10">
                <div className="max-w-3xl">
                    <p className="text-xs uppercase tracking-[0.28em] text-[#C46A42] font-medium">
                        What we do
                    </p>
                    <h2 className="font-display text-4xl md:text-6xl text-[#1B3B2B] mt-3 leading-[1.05]">
                        Everything for the road ahead.
                    </h2>
                    <p className="mt-5 text-[#4B5563] max-w-xl">
                        One trusted team for packages, cabs, buses and
                        celebrations — always a phone call away.
                    </p>
                </div>

                <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
                    {services.map((s, i) => {
                        const Icon = s.icon;
                        return (
                            <div
                                key={i}
                                data-testid={`${HOME.serviceCard}-${i}`}
                                className="group rounded-2xl bg-white p-7 ring-1 ring-black/5 hover:ring-[#1B3B2B]/20 hover:-translate-y-1 hover:shadow-lg transition-[transform,box-shadow,--tw-ring-color] duration-300"
                            >
                                <div className="grid h-11 w-11 place-items-center rounded-full bg-[#1B3B2B]/10 text-[#1B3B2B] group-hover:bg-[#1B3B2B] group-hover:text-white transition-colors duration-300">
                                    <Icon className="h-5 w-5" />
                                </div>
                                <h3 className="mt-6 font-display text-2xl text-[#1B3B2B]">
                                    {s.title}
                                </h3>
                                <p className="mt-3 text-[#4B5563] leading-relaxed">
                                    {s.desc}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Services;
